import { joinJSXElement } from "modules/Booking/FormPage/common/utils/joinJSXElement"
import styles from "modules/Booking/FormPage/components/UserInfoWithForm/components/ErrorsAcception/styles.module.scss"

interface ErrorsAcceptionProps {
    psyOfferAccepted: boolean
    eulaAccepted: boolean
    informedAgreement: boolean
}

export function ErrorsAcception({
    psyOfferAccepted,
    eulaAccepted,
    informedAgreement,
}: ErrorsAcceptionProps) {
    const result: JSX.Element[] = []
    const psyOfferAcceptedText = <>примите оферту психолога</>
    const eulaAcceptedText = <>примите оферту сервиса</>
    const informedAgreementText = <>ознакомьтесь с&nbsp;информированным согласием</>

    if (!psyOfferAccepted) {
        result.push(psyOfferAcceptedText)
    }
    if (!eulaAccepted) {
        result.push(eulaAcceptedText)
    }
    if (!informedAgreement) {
        result.push(informedAgreementText)
    }

    return (
        <div className={styles.container} data-test-id="booking-form-acception-errors">
            {joinJSXElement(result)}
            {result.length > 0 && "."}
        </div>
    )
}
